import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { CreditCard, CheckCircle2 } from "lucide-react";

function NotAffiliate() {
  return (
    <div className="card-dark p-6" data-testid="connect-not-affiliate">
      <div className="label-mono mb-2 flex items-center gap-2"><CreditCard className="w-3 h-3"/>INCASSA LE CAPARRE</div>
      <p className="text-sm text-neutral-400">Vuoi ricevere direttamente le caparre dei tuoi tavoli? Chiedi al PR di attivarti come affiliato.</p>
    </div>
  );
}

export default function ConnectStripeCard() {
  const { user, refresh } = useAuth();
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const isAffiliate = user?.role === "affiliate";

  useEffect(() => {
    if (!isAffiliate) { return; }
    api.get("/connect/status").then(r => { setSt(r.data); refresh(); }).catch(() => setSt({ connected: false }));
  }, [isAffiliate, refresh]);

  if (!isAffiliate) return <NotAffiliate/>;

  const connect = async () => {
    setBusy(true);
    try { const { data } = await api.post("/connect/onboard"); window.location.href = data.url; }
    catch (e) { toast.error(e.response?.data?.detail || "Errore collegamento Stripe"); setBusy(false); }
  };

  const ready = st?.charges_enabled;
  return (
    <div className={`card-dark p-6 ${ready ? "border-neon" : "border-alert"}`} data-testid="connect-card">
      <div className="label-mono mb-2 flex items-center gap-2"><CreditCard className="w-3 h-3"/>CONTO STRIPE PER LE CAPARRE</div>
      {ready ? (
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-2 text-neon font-display text-xl" data-testid="connect-status-ok"><CheckCircle2 className="w-5 h-5"/>COLLEGATO</div>
          <Link to="/incassi" className="btn-ghost !py-2 !px-4 text-xs" data-testid="connect-earnings-link">VEDI I MIEI INCASSI</Link>
        </div>
      ) : (
        <>
          <p className="text-sm text-neutral-400 mb-4" data-testid="connect-status-pending">
            {st?.details_submitted ? "Stripe sta verificando i tuoi dati. Torna più tardi." : "Collega il tuo conto Stripe: le caparre dei tavoli che crei arriveranno direttamente a te."}
          </p>
          <button onClick={connect} disabled={busy} className="btn-primary !py-2 !px-4 text-xs" data-testid="connect-stripe-btn">
            {busy ? "..." : st?.connected ? "COMPLETA SU STRIPE" : "COLLEGA STRIPE"}
          </button>
        </>
      )}
    </div>
  );
}
